export default __webpack_public_path__ + "static/media/requests-icon.ce96088a.svg";